import { FilterState } from './reducer'

export const getFilters = (state: { filter: FilterState }) => state.filter
